module.exports = __webpack_public_path__ + "img/05.bac2d904.jpg";